import React from "react";
import { Route } from "react-router-dom";
import lazyWithRetry from "helpers/lazyWithRetry";

const IndexEcolixExplorerPage = lazyWithRetry(() =>
  import("./IndexEcolixExplorerPage")
);

export default [
  <Route
    exact
    path="/ecolix"
    key="ecolix-explorer"
    component={IndexEcolixExplorerPage}
  />,
];
